import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './pages/Home/Home';
import Login from './pages/Login/Login';
import ProductSection from './pages/ProductSection/ProductSection';
import Register from './pages/Register/Register';
import Seller from './pages/Seller/Seller';
import Explore from './pages/Explore/Explore';
import Profile from './pages/Profile/Profile';

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="/" exact>
          <Home/>
        </Route>
        <Route path="/login" exact>
          <Login/>
        </Route>
        <Route path="/register" exact>
          <Register/>
        </Route>
        <Route path="/sell">
          <Seller/>
        </Route>
        <Route path='/product/:id'>
          <ProductSection/>
        </Route>
        <Route path="/explore">
          <Explore/>
        </Route>
        <Route path="/profile">
          <Profile/>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
